import { CopyOnClick, H3, P, Skeleton } from '@dnb/eufemia';
import { JSX, useMemo } from 'react';

import { useBackend } from '@/hooks/useBackend';

interface Props {
  apiSlug: string;
  teamId: string;
}

export function TeamOverview({ apiSlug, teamId }: Props): JSX.Element {
  const { data: team, isLoading } = useBackend(`/apis/{apiSlug}/teams/{teamId}`, {
    params: { path: { apiSlug, teamId } },
  });

  const teamAdminsSorted = useMemo(
    () =>
      team?.admins.toSorted((a, b) => {
        const nameA = `${a.firstName} ${a.lastName}`;
        const nameB = `${b.firstName} ${b.lastName}`;
        return nameA.localeCompare(nameB);
      }),
    [team],
  );

  return (
    <Skeleton show={isLoading}>
      <div className="grid grid-cols-2 gap-x-2 gap-y-4">
        <div>
          <P>Team name</P>
          <CopyOnClick className="text-basis text-black-55">{team?.name}</CopyOnClick>
        </div>
        <div>
          <P>Team ID</P>
          <CopyOnClick className="text-basis text-black-55">{team?.id}</CopyOnClick>
        </div>
        <div>
          <P>Organization name</P>
          <CopyOnClick className="text-basis text-black-55">{team?.organization.name}</CopyOnClick>
        </div>
        <div>
          <P>Organization ID</P>
          <CopyOnClick className="text-basis text-black-55">{team?.organization.id}</CopyOnClick>
        </div>
      </div>
      <H3 bottom="small" top="medium">
        Admins
      </H3>
      <div className="grid grid-cols-2 gap-x-2 gap-y-4">
        {teamAdminsSorted?.map((teamAdmin) => (
          <div key={teamAdmin.email}>
            <P>
              {teamAdmin.firstName} {teamAdmin.lastName}
            </P>
            <CopyOnClick className="text-basis text-black-55">{teamAdmin.email}</CopyOnClick>
          </div>
        ))}
      </div>
    </Skeleton>
  );
}
